<template>
    <div class="row">
        <div class="col-12 col-md-6 order-md-2">
            <!-- Card -->
            <div class="card bg-light border ml-md-4">
                <div class="card-body">
                    <p class="mb-2">{{$t('Password suggestions')}}</p>
                    <p
                        class="small text-muted mb-2"
                    >{{$t('To create a new strong password, you have to meet all of the following requirements:')}}</p>

                    <ul class="small text-muted pl-4 mb-0">
                        <li>{{$t('Minimum 8 character')}}</li>
                        <li>{{$t('At least one special character (#%.,)')}}</li>
                        <li>{{$t('At least one number')}}</li>
                        <li>{{$t('Can’t be the same as a previous password')}}</li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="col-12 col-md-6">
            <form @submit.prevent="updatePassword">
                <div class="form-group">
                    <label>{{ $t('Password') }}</label>
                    <password-viewable v-model="data.oldPassword"
                                       :state="validation.oldPassword"
                                       :error-message="errors.oldPassword"
                                       :placeholder="$t('Current password')"></password-viewable>
                </div>
                <div class="form-group">
                    <label>{{ $t('New password') }}</label>
                    <password-viewable v-model="data.newPassword"
                                       :state="validation.newPassword"
                                       :error-message="errors.newPassword"
                                       :placeholder="$t('New password')"></password-viewable>
                </div>
                <div class="form-group">
                    <label>{{ $t('Confirm new password') }}</label>
                    <password-viewable v-model="data.confirmPassword"
                                       :state="validation.confirmPassword"
                                       :error-message="errors.confirmPassword"
                                       :placeholder="$t('Confirm new password')"></password-viewable>
                </div>
                <button-loading
                    type="submit"
                    :loading="loading"
                    @click="updatePassword()"
                    class="btn btn-primary"
                >{{ $t('Update password') }}
                </button-loading>
            </form>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import PasswordViewable from '@/components/PasswordViewable.vue'
import ButtonLoading from '@/components/ButtonLoading'

export default {
    components: {
        PasswordViewable,
        ButtonLoading
    },
    data() {
        return {
            data: { oldPassword: '', newPassword: '', confirmPassword: '' },
            validation: { oldPassword: null, newPassword: null, confirmPassword: null },
            errors: { oldPassword: '', newPassword: '', confirmPassword: '' }
        }
    },
    computed: {
        ...mapState('auth', [
            'user'
        ]),
        ...mapState('authManagement', { loading: 'isCreatePending' }),
        ...mapGetters('users', {
            getUserById: 'get'
        }),

    },
    created() {
        this.getUser(this.user._id);
    },
    methods: {
        ...mapActions('users', {
            getUser: 'get',
        }),
        ...mapActions('authManagement', {
            changePassword: 'create'
        }),

        validate() {
            let valid = true
            let errors = {}
            let keys = ['oldPassword', 'newPassword', 'confirmPassword']
            keys.forEach(key => {
                let value = !!this.data[key]
                valid &= value
                if (!value)
                    errors[key] = 'This field is required'
            }, {})
            this.setErrors(errors)
            return { errors, valid }
        },

        setErrors(errors) {
            this.errors = {}
            this.validation = {}
            Object.entries(errors).forEach(([key, message]) => {
                this.$set(this.errors, key, this.$t(message))
                this.$set(this.validation, key, false)
            })
        },

        updatePassword() {
            if (this.data.newPassword !== this.data.confirmPassword)
                return this.setErrors({ confirmPassword: 'Passwords do not match' })
            let { valid } = this.validate()
            if (!valid)
                return

            this.changePassword([{
                action: 'passwordChange',
                value: {
                    user: {
                        email: this.user.email
                    },
                    oldPassword: this.data.oldPassword,
                    password: this.data.newPassword
                }
            }, {}]).then(() => {
                this.$toasted.global.success({
                    message: this.$t('Password has been changed')
                });
                this.data = {};
                this.errors = {}
                this.validation = {}
            }).catch(error => {
                this.setErrors(error.errors)
            });


        }
    },
}
</script>

<style>

</style>
